class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDrawer());    
    this.querySelector('#CartDrawer--overlay').addEventListener('click', () => this.closeDrawer());    
    document.querySelector('#cart-icon-bubble').addEventListener('click', (e) => {  
      e.preventDefault()
      this.openDrawer()        
    });
    this.timeoutProducts();
  }    

  openDrawer() {  
    //document.activeElement.blur()         
    //document.querySelector('.drawer__container').focus()    
    if(!document.getElementById('CARTDRAWER')) {
      //loadCss('cart-drawer');

      setTimeout(() => {
        document.querySelector('cart-drawer').classList.add('drawer--active');  
        document.body.classList.add('drawer--open');  
      }, 250)      
    } else {
      document.querySelector('cart-drawer').classList.add('drawer--active');  
      document.body.classList.add('drawer--open');  
    }  
    
    if (document.querySelectorAll('drawer-dialog dialog[open]').length > 0) {
      document.querySelectorAll('drawer-dialog dialog[open]').forEach((e) => {
        e.closest('drawer-dialog').hide();
      });
    }

    setTimeout(() => {
      const containerToTrapFocusOn = this.querySelector('.drawer__container')
      const focusElement = this.querySelector('#cartClose')
      trapFocus(containerToTrapFocusOn, focusElement);        
    }, 500)          
  }

  closeDrawer() {           

    if (document.querySelectorAll('drawer-dialog .drawer__container[open]').length == 0) {
      document.querySelector('cart-drawer').classList.remove('drawer--active');  
      document.body.classList.remove('drawer--open');  
    } else {
      document.querySelector('cart-drawer').classList.remove('drawer--active');  
    }

    removeTrapFocus(this);    
    trapFocus(document.body, document.getElementById('cart-icon-bubble'));        
  }

  renderContents(parsedState) {        
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    
    this.openDrawer();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  timeoutProducts(){
    //console.log('timeoutProducts');
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
      //console.log('cartContents', data.items);
      let itemsToRemove = [];

      data.items.forEach(item => {
        //console.log('item', item);
        if(item.properties.hasOwnProperty('_addedDateTime')) {
          const addedDate = new Date(parseInt(item.properties._addedDateTime * 1000));
          const now = new Date();

          //const FIVE_MINUTES = 5 * 60 * 1000;

          const timeout = 5 * 60 * 60 * 1000;

          //console.log('now')
          //console.log(now.getTime())

          //console.log('addedDate')
          //console.log(addedDate.getTime())

          //console.log('now - addedDate')
          //console.log(now.getTime() - addedDate.getTime())

          if((now.getTime() - addedDate.getTime()) > timeout){
            //console.log('Item added more than timeout');
            itemsToRemove.push(item.id);
          }
        }
      })

      itemsToRemove.forEach((item) => {
        console.log('Removing item', item);
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'id': item.toString(),  
            'quantity': 0,
            'sections': "cart-drawer,cart-icon-bubble"
          })
        })
        .then(response => response.json())
        .then(response => {
          window.location.reload();
        })    
      });

      //return data 
    });

  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__container'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
